export default function PolicyholderValidation(values) {
  console.log("validation", values);
  const errors = {};
  if (!values.tradeName) {
    errors.tradeName = "Field is required";
  }
  if (!values.mainActivity) {
    errors.mainActivity = "Field is required";
  }
  if (!values.contactName) {
    errors.contactName = "Field is required";
  }
  if (!values.shortName) {
    errors.shortName = "Field is required";
  }
  if (!values.niu) {
    errors.niu = "NIU is required";
  }
  if (!values.rccm) {
    errors.rccm = "No. RCCM is required";
  }
  // if (!values.dateValidFrom) {
  //   errors.dateValidFrom = "Created Date is required";
  // }
  if (!!values.rccm && !values.createdAt) {
    errors.createdAt = "Created At is required";
  }
  // if (!values.nbEmployees) {
  //   errors.nbEmployees = "No. of Employees is required";
  // }
  if (!values.region) {
    errors.region = "Field is required";
  }
  if (!values.city) {
    errors.city = "Field is required";
  }
  if (!values.municipality) {
    errors.municipality = "Field is required";
  }
  if (!values.village) {
    errors.village = "Field is required";
  }
  if (!values.address) {
    errors.address = "Field is required";
  }
  if (!values.phone) {
    errors.phone = "Field is required";
  }
  // if (!values.email) {
  //   errors.email = "Email is required";
  // }
  if (!values.legalForm) {
    errors.legalForm = "Field is required";
  }
  if (!values.activityCode) {
    errors.activityCode = "Field is required";
  }
  if (!values.contributionPlanBundle) {
    errors.contributionPlanBundle = "Field is required";
  }
  // if (!values.bank) {
  //   errors.bank = "Bank Name is required";
  // }
  // if (!values.bankCode) {
  //   errors.bankCode = "Bank Code is required";
  // }
  // if (!values.lockerCode) {
  //   errors.lockerCode = "Bank Locker Code is required";
  // }
  // if (!values.accountNb) {
  //   errors.accountNb = "Bank Account No is required";
  // }
  // if (!!values.bankKey) {
  //   errors.bankKey = "RIB Key is required";
  // }
  if (!!values.bankKey) {
    if (!/^\d{1,2}$/.test(values.bankKey)) {
      errors.bankKey = "RIB Key must be a 1 or 2 digit number";
    }
  }
  return errors;
}
